var map = {
	"./Inventory.svg": "d800",
	"./add-file.svg": "9f1c",
	"./add-folder.svg": "37e0",
	"./add-folder1.svg": "1683",
	"./add-item.svg": "e282",
	"./alert-circle.png": "dd9d",
	"./alert-no-set.svg": "251c",
	"./alert-read.svg": "edc7",
	"./alert-red.svg": "1c22",
	"./alert-set.svg": "6631",
	"./alert-unread.svg": "d6f9",
	"./alert-white.svg": "e869",
	"./alert-yellow.svg": "3838",
	"./alert.svg": "e6c5",
	"./amex.svg": "d182",
	"./android.svg": "e265",
	"./apple.svg": "4644",
	"./arrow-right.svg": "55b9",
	"./at.svg": "a518",
	"./attached-file.svg": "314f",
	"./barcode-btn.svg": "4dc9",
	"./bell-no-white.svg": "2cfd",
	"./bell-white.svg": "b422",
	"./boxes.svg": "c79b",
	"./browser.svg": "22a5",
	"./businessman.svg": "d66c",
	"./calendar.svg": "287d",
	"./cardboard-box.svg": "5aae",
	"./check-bold-black.svg": "c06f",
	"./check-bold.svg": "3b62",
	"./check-color.svg": "3a85",
	"./check.svg": "a7c0",
	"./checkbox.svg": "9ec1",
	"./copy.svg": "c0a5",
	"./csv-file.svg": "1591",
	"./dashboard.svg": "7154",
	"./date.svg": "a2bf",
	"./delete.svg": "a3dd",
	"./delete1.svg": "3d5f",
	"./delivery-box.svg": "9f1d",
	"./diners.svg": "6d36",
	"./dossier.svg": "dfe4",
	"./download-m.svg": "9f08",
	"./download.svg": "039a",
	"./draw.svg": "75f4",
	"./dropdown.svg": "74e6",
	"./email.svg": "caf7",
	"./error-color.svg": "f5c4",
	"./export.svg": "8354",
	"./file.svg": "493c",
	"./folder-color.svg": "21f2",
	"./folder.svg": "5a71",
	"./foreign.svg": "9a10",
	"./funnel.svg": "d5c9",
	"./garbage-can.svg": "9a00",
	"./help.svg": "86c0",
	"./hide-black.svg": "da23",
	"./hide.svg": "76e2",
	"./history.svg": "7afb",
	"./home.svg": "0331",
	"./image.svg": "8ad7",
	"./import.svg": "1fb4",
	"./import2.svg": "6680",
	"./info.svg": "b888",
	"./insurance.svg": "4015",
	"./integration.svg": "0b3e",
	"./list.svg": "3561",
	"./loading-svgrepo-com.svg": "4179",
	"./logo-britecheck.svg": "c9ff",
	"./mastercard.svg": "543b",
	"./menu.svg": "f3d1",
	"./money.svg": "4955",
	"./move.svg": "35ac",
	"./next.svg": "8def",
	"./notification.svg": "b3f3",
	"./notificationItem.svg": "604c2",
	"./number-seven.svg": "b2ef",
	"./package.svg": "3405",
	"./pdf-file.svg": "5659",
	"./pencil.svg": "9255",
	"./pencil2.svg": "9287",
	"./phone-call.svg": "1db8",
	"./plus.svg": "701f",
	"./plus2.svg": "8a4c",
	"./plus3.svg": "57bf",
	"./previous.svg": "944c",
	"./qr-code-btn.svg": "3f5e",
	"./refund.svg": "c28f",
	"./report-menu.svg": "d097",
	"./scan-1.svg": "f8b1",
	"./settings.svg": "9c15",
	"./smartphone-call.svg": "6473",
	"./sort-down.svg": "d0aa",
	"./sort-up.svg": "8f5f",
	"./tags.svg": "be28",
	"./totalFolder.svg": "1e42",
	"./totalItem.svg": "893e",
	"./totalQty.svg": "9219",
	"./totalValue.svg": "245e",
	"./trash.svg": "53bd",
	"./unionpay.svg": "b242",
	"./upload_barcode.svg": "80b6",
	"./upload_icon.svg": "4d43",
	"./users.svg": "4a04",
	"./verified.svg": "a21e",
	"./visa.svg": "53f8",
	"./vision-grey.svg": "2cad",
	"./vision.svg": "4e48",
	"./warehouse.svg": "f69a",
	"./wm-rack.svg": "a307",
	"./wm-rack2.svg": "e744"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5c4a";